import FanPagesSelector from "./FanPagesSelector";

export default FanPagesSelector;
